import { Tab, Tabs, styled } from '../../Material/index'
import colors from '../../../colors'

interface CustomTabProps {
  onClick?: () => void
  label?: string
}

export const CustomTab = styled(({ onClick, label, ...props }: CustomTabProps) => (
  <Tab title={label || ''} onClick={onClick} label={label} disableRipple {...props} />
))({
  textTransform: 'none',
  flexGrow: 1,
  fontFamily: 'BB-Font-Bold',
  fontWeight: 'bold'
})

export const CustomTabs = styled(Tabs)({
  width: '100%',
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '&::before': {
      backgroundColor: colors['blue-bb'],
      height: '4px',
      width: '40%',
      content: '""'
    }
  }
})
